<ngx-spinner
  bdColor="rgba(250,250, 250, 0.8)"
  size="default"
  color="#000000"
  type=""
  [fullScreen]="fullScreen === true"
  [name]="name"
  size="default"
  type="ball-spin-clockwise"
  [zIndex]="fullScreen ? 2147483640 : 7"
>
</ngx-spinner>
